export default __webpack_public_path__ + "static/media/science_img04.ef5d0fa5.png";